
        import 'TableCell.02c07fa.css-module'
        export default {"icon":"icon_TableCell_02c07fa"}
    